// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { deviceUtils } from '@openbank/cf-ui-architecture-core';
// Components
import { LinkComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { FINANCIAL_DATA_EDIT_LINK_PROPS } from './constants/financial-data-edit-link.constants';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Handlers
import { PreContractTrackingHandlers } from 'containers/contract/views/pre-contractual/handlers/pre-contract.view.tracking.handlers';
// Translations
import { CHANGE_IBAN } from '../../translations/financial-data.component.translations';
// Types
import { FinancialDataEditLinkComponentType } from './types/financial-data-edit-link.component.type';

const FinancialDataEditLinkComponent = ({
  setShowIbanSelector,
}: FinancialDataEditLinkComponentType): React.JSX.Element => {
  const { handleEditIbanButonClickTracking } = useAppTrackingHook(PreContractTrackingHandlers);

  return (
    <LinkComponent
      {...FINANCIAL_DATA_EDIT_LINK_PROPS}
      onClick={ev => {
        ev.preventDefault();
        if (setShowIbanSelector) {
          handleEditIbanButonClickTracking();
          setShowIbanSelector(true);
        }
      }}
    >
      {!deviceUtils.isMobileDevice() ? <FormattedMessage id={CHANGE_IBAN} /> : ''}
    </LinkComponent>
  );
};

export { FinancialDataEditLinkComponent };
